/**
 * @generated SignedSource<<d2afb45244b6d92a1f33fc013c8595d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbReturnPolicy_item" | "PdpRespSidebarBlurbShipping_item" | "useShowReturns_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbReturnPolicy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowReturns_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "9f3fd418a40927510cd73fe9a8288b09";

export default node;
